class Pagination {

    constructor(element) {
        this.container = element;
        this.post_id = this.container.getAttribute('data-post-id');
        this.bindTrigger();
        this.ajax_feed = document.querySelector('body').classList.contains('page-template-productions-list') ? 'productions_feed' : 'articles_feed';
    }

    bindTrigger() {
        console.log('this.post_id', this.post_id)
        this.button = document.querySelector('.trigger');
        if (this.button) {
            this.button.addEventListener('click', this.handleClick.bind(this));
        }
    }

    getPageFromUrl(url) {
        const match = url.match(/page\/(\d+)(\/|$)/);
        return match ? match[1] : 1;
    }

    handleClick(event) {
        event.preventDefault();
        const pageNumber = this.getPageFromUrl(this.button.getAttribute('href'));
        const ajaxUrl = `${ajax_client.ajax_url}?action=${this.ajax_feed}&ajax=true&paged=${pageNumber}&post_id=${this.post_id}`;

        fetch(ajaxUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // Extract the cards from the new grid
                const cards = Array.from(doc.querySelectorAll('[data-listing] article'));
                if (cards.length) {
                    cards.forEach(card => {
                        this.container.appendChild(card);
                    });
                }

                // Update the pagination
                const newPagination = doc.querySelector('.pagination');
                const currentPagination = document.querySelector('.pagination');

                if (newPagination) {
                    currentPagination.innerHTML = newPagination.innerHTML;
                } else if (currentPagination) {
                    currentPagination.remove();
                }

                this.bindTrigger();
                
            })
            .catch(error => console.error('Error fetching articles:', error));
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector("[data-listing]");

    if (element) {
        new Pagination(element);
    }
    
});

